import { render, staticRenderFns } from "./WealthPortfolioBackground.vue?vue&type=template&id=6a210d5c&scoped=true"
import script from "./WealthPortfolioBackground.vue?vue&type=script&lang=ts"
export * from "./WealthPortfolioBackground.vue?vue&type=script&lang=ts"
import style0 from "./WealthPortfolioBackground.vue?vue&type=style&index=0&id=6a210d5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a210d5c",
  null
  
)

export default component.exports